import { PointHistory } from '@/features/Point';

const PointHistoryPage = () => {
  return <PointHistory />;
};

export default PointHistoryPage;
